/**
 * Analytics section types enumeration
 * @enum {string}
 */
const AnalyticsSectionTypes = Object.freeze({
  ALTERNATIVES: 'ALTERNATIVES',
  DID_YOU_FORGET: 'DID_YOU_FORGET',
  FAVOURITES: 'FAVOURITES',
  FEATURED: 'FEATURED',
  FLASH_SALES: 'FLASH_SALES',
  HAVE_YOU_RUN_OUT_OF: 'HAVE_YOU_RUN_OUT_OF',
  HEALTHIFY: 'HEALTHIFY',
  INCOMPLETE_OFFERS_IN_YOUR_TROLLEY: 'INCOMPLETE_OFFERS_IN_YOUR_TROLLEY',
  NA: 'NA',
  NEW: 'NEW',
  OFFERS_ON_YOUR_FAVOURITES: 'OFFERS_ON_YOUR_FAVOURITES',
  ON_OFFER: 'ON_OFFER',
  OTHER: 'OTHER',
  PERSONALISED_COUPONS: 'PERSONALISED_COUPONS',
  RECOMMENDATIONS_COW: 'RECOMMENDATIONS_COW',
  RECOMMENDED: 'RECOMMENDED',
  RECOMMENDED_SIDEBAR: 'RECOMMENDED_SIDEBAR',
  SPECIAL_OFFERS_YOU_MIGHT_LIKE: 'SPECIAL_OFFERS_YOU_MIGHT_LIKE',
  SPONSORED: 'SPONSORED',
  SUGGESTED_ORDER: 'SUGGESTED_ORDER',
  TOP_OFFERS: 'TOP_OFFERS',
  TRY_SOMETHING_NEW: 'TRY_SOMETHING_NEW',
  YOU_MIGHT_LIKE: 'YOU_MIGHT_LIKE',
});

export default AnalyticsSectionTypes;
